import { Box, ThemeProvider } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { useAmbassadors } from "@/modules/ambassadors/hooks/ambassadors.hook";
import { AmbassadorHeader } from "@/modules/ambassadors/components/ambassador-header";
import DataTable from "@/modules/common/components/tables/data-table";
import { useAmbassadorUserColumns } from "@/modules/ambassadors/hooks/ambassadors-user-columns.hook";

export default function UserView() {
  const {
    page,
    rowsPerPage,
    ambassadorsWithLeadsCount,
    totalCount,
    isLoading,
    error,
    handlePaginationChange,
    handleViewLeads,
    isLoadingLeadsCount,
  } = useAmbassadors();

  const columns = useAmbassadorUserColumns(
    isLoadingLeadsCount,
    handleViewLeads
  );

  return (
    <ThemeProvider theme={nawyTheme}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: nawyTheme.nawy.spacing.md,
          p: nawyTheme.nawy.spacing.md,
        }}
      >
        <AmbassadorHeader
          title="Ambassadors"
          loading={isLoading}
          count={totalCount}
        />

        <Box sx={{ width: "100%" }}>
          <DataTable
            name="Ambassadors"
            columns={columns}
            rowCount={totalCount}
            data={ambassadorsWithLeadsCount || []}
            showRowCount={false}
            showTopBar={false}
            enableRowSelection={false}
            enableColumnResizing={true}
            showColumnVisibility={false}
            pagination={{ pageIndex: page, pageSize: rowsPerPage }}
            setPagination={handlePaginationChange}
            isLoading={isLoading}
            isError={!!error}
            height="calc(100vh - 100px)"
            width="100%"
            tableLayout="full"
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
